const formatDataUri = uri => uri.split(',')[1];

export default formatDataUri;
